var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "(lc) logos"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.20962 13.1907L1.91523 14.4095C2.06186 14.6661 2.27262 14.8677 2.52005 15.0143L5.04009 10.6523H0C0 10.9364 0.0733104 11.2205 0.219931 11.4771L1.20962 13.1907Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 5.52213L5.47995 1.16016C5.23253 1.30678 5.02176 1.50838 4.87514 1.76497L0.219931 9.82911C0.0751432 10.0802 0 10.3643 0 10.6539H5.04009L8 5.52213Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.4799 15.0143C13.7274 14.8677 13.9381 14.6661 14.0848 14.4095L14.378 13.9055L15.7801 11.4771C15.9267 11.2205 16 10.9364 16 10.6523H10.9599L12.0321 12.76L13.4799 15.0143Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.00003 5.52135L10.5201 1.15938C10.2726 1.01276 9.98857 0.939453 9.69533 0.939453H6.30472C6.01148 0.939453 5.7274 1.02193 5.47998 1.15938L8.00003 5.52135Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.9599 10.6523H5.04007L2.52002 15.0143C2.76744 15.1609 3.05152 15.2342 3.34476 15.2342H12.6552C12.9484 15.2342 13.2325 15.1518 13.4799 15.0143L10.9599 10.6523Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.4525 5.79704L11.1249 1.76497C10.9782 1.50838 10.7675 1.30678 10.52 1.16016L8 5.52213L10.9599 10.6539H15.9908C15.9908 10.3698 15.9175 10.0857 15.7709 9.82911L13.4525 5.79704Z",
    fill: "#FFBA00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.759c455e8185fb8ba6eac21b04fd304c.svg";
export { ForwardRef as ReactComponent };